module.exports = __webpack_public_path__ + "static/reward-568907d0b7d4ee76797bd27177d719ad.png";